import { CloseOutlined } from "@ant-design/icons";
import classnames from "classnames";
import React from "react";
import IFrequentlyUsedOrderSearchCriteriaDto from "./type";
import useDragDrop from "@/hooks/useDragDrop";
import { message } from "antd";

interface CriteriaItemProps {
    index: number;

    orderSearchCriteria: IFrequentlyUsedOrderSearchCriteriaDto;

    active: React.Key;

    onActive(id: React.Key): void;

    onRemove(id: React.Key): void;

    onSortChange?(from: number, to: number): void;

    onSortChangeEnd?(): void;

    disabledDrag?: boolean;
}

const CriteriaItem: React.FC<CriteriaItemProps> = function (props) {
    const {
        index,
        orderSearchCriteria,
        active,
        onActive,
        onRemove,
        onSortChange,
        onSortChangeEnd,
        disabledDrag,
    } = props;

    const { id } = orderSearchCriteria;

    function handleActive() {
        onActive(id);
    }

    function handleRemove(e: React.MouseEvent) {
        e.stopPropagation();

        onRemove(id);
    }

    const { ref, opacity } = useDragDrop({
        index,
        onChange: onSortChange,
        onChangeEnd: onSortChangeEnd,
        canDrag() {
            if (disabledDrag) {
                message.error("请先保存添加的搜索条件后再排序");
            }

            return !disabledDrag;
        },
    });

    return (
        <div
            ref={ref}
            onClick={handleActive}
            className={classnames("order-search-criteria-item", active === id && "active")}
            style={{ opacity }}
        >
            <span className="text">{orderSearchCriteria.name}</span>

            <CloseOutlined className="delete-icon" onClick={handleRemove} />
        </div>
    );
};

export default React.memo(CriteriaItem);
